import * as React from 'react';
import { Subscribe } from 'unstated';

import StateContainer from '../StateContainer';
import ProductFiles from './ProductFiles';

export interface IProductFilesTabProps {
    container: StateContainer;
    removeFile: (obj: any) => void;
    shouldUpdate: boolean;
}

export class ProductFilesTab extends React.Component<IProductFilesTabProps> {

    public shouldComponentUpdate() {
        return this.props.shouldUpdate;
    }

    public render() {
        const { container } = this.props;

        return (
            <Subscribe to={[container]}>
                {productDetail => (
                    <ProductFiles
                        removeFile={(obj: any) => this.props.removeFile(obj)}
                        onChange={(val: any) => container.onChange('files', val)}
                        productFiles={productDetail.state.product.files} // all files for product, no filtering
                        productId={productDetail.state.product.id}
                    />
                )}
            </Subscribe>
        );
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductFilesTab/ProductFilesTab.tsx